import template from './edit-substitution-realization.html';

class EditSubstitutionRealizationComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, $stateParams, moment,
    RealizationService,
    SubstitutionService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.moment = moment;
    this.RealizationService = RealizationService;
    this.SubstitutionService = SubstitutionService;

    this.date = new Date();
  }

  $onChanges(changes) {
    if (changes.realization) {
      this.realization = {...this.realization};
    }
  }

  $onInit() {
    this.startTime = this.realization.startTime;
    this.endTime = this.realization.endTime;
    this.date = this.moment(this.realization.date);
    if (this.realization.substituteActivity) {
      this.SubstitutionService.getActivity(this.realization.substituteActivity).then(substitution => {
        this.substitution = substitution;
      })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    }
  }

  edit(form) {
    if (form.$invalid) {
      return false;
    }

    this.realization.date = this.date.format('YYYY-MM-DD');
    this.realization.startTime = this.startTime;
    this.realization.endTime = this.endTime;
    this.realization.substituteActivityId = this.$stateParams.activityId;
    this.RealizationService.edit({realization: this.realization})
      .then(() => {
        this.$state.go('modules.realizations.byEmployee');
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Edytowano realizację')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const EditSubstitutionRealization = {
  bindings: {
    realization: '<'
  },
  template,
  controller: EditSubstitutionRealizationComponent
};
